import type { Parent, ParentCreatePayload, ParentFormErrors, ParentFormValues, ParentUpdatePayload } from "../types";

export const defaultParentFormValues: ParentFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  address: "",
  zipCode: "",
  city: "",
  newsletterOptOut: false,
};

const normalize = (value: string | null | undefined): string => String(value ?? "").trim();

export const mapParentToFormValues = (parent?: Partial<Parent> | null): ParentFormValues => ({
  firstName: normalize(parent?.firstName),
  lastName: normalize(parent?.lastName),
  email: normalize(parent?.email),
  phone: normalize(parent?.phone),
  address: normalize(parent?.address),
  zipCode: normalize(parent?.zipCode),
  city: normalize(parent?.city),
  newsletterOptOut: Boolean(parent?.newsletterOptOut),
});

export const validateParentForm = (values: ParentFormValues): ParentFormErrors => {
  const errors: ParentFormErrors = {};
  if (!normalize(values.firstName)) errors.firstName = "required";
  if (!normalize(values.lastName)) errors.lastName = "required";
  if (!normalize(values.email)) {
    errors.email = "required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) {
    errors.email = "invalid";
  }
  return errors;
};

export const hasParentFormErrors = (errors: ParentFormErrors): boolean => Object.keys(errors).length > 0;

export const mapFormToCreatePayload = (values: ParentFormValues): ParentCreatePayload => ({
  firstName: normalize(values.firstName),
  lastName: normalize(values.lastName),
  email: normalize(values.email),
  phone: normalize(values.phone),
  address: normalize(values.address),
  zipCode: normalize(values.zipCode),
  city: normalize(values.city),
});

export const mapFormToUpdatePayload = (values: ParentFormValues): ParentUpdatePayload => ({
  ...mapFormToCreatePayload(values),
  newsletterOptOut: Boolean(values.newsletterOptOut),
});
